import * as React from 'react';
import Button from 'src/components/common/Button';
import SearchBar from 'src/components/SearchBar';
import Alert from 'src/components/common/Alert';

import './CartActions.scss';
import { ICartSuccess } from 'src/store/modules/cart/reducers';
import i18n from 'src/translation/i18n';
import env from 'src/shared/env';

interface ICartActionsProps {
  onClearCart?: () => void;
  onSelectSearchItem?: (partID: string, manufacturer: string,category: string) => void;
  onChangeQuantity?: (quantity: number) => void;
  onAddItem?: () => void;
  onUploadFile: () => void;
  cartSuccess: ICartSuccess;
  onCloseAlertSuccess: (success: ICartSuccess) => void;
  t?: any;
}

export default class CartActions extends React.PureComponent<
  ICartActionsProps,
  any
> {
  private selectedPart = (partID: string, manufacturer: string, category: string) => {
    if (this.props.onSelectSearchItem) {
      this.props.onSelectSearchItem(partID,manufacturer,category);
    }
  };

  private submitSearch = (searchText: string) => {
    if (this.props.onAddItem) {
      this.props.onAddItem();
    }
  };

  private changeQuantity: React.ChangeEventHandler<
    HTMLInputElement
  > = event => {
    if (this.props.onChangeQuantity) {
      this.props.onChangeQuantity(+event.target.value);
    }
  };

  private addItem = () => {
    if (this.props.onAddItem) {
      this.props.onAddItem();
      this.props.onChangeQuantity(1);
    }
  };

  private loadFileClick = () => {
    document.getElementById('upload').click();
  };

  public render() {
    const { onClearCart } = this.props;
    return (
      <div className="row cart-view--items-section--add-item-form justify-content-between">
        {this.props.cartSuccess.hasSucced && (
          <Alert
            styleClass="rp-lists-alert-cart"
            message={i18n.t('common.itemAddedTocartTxt')}
            icon={'rpds-check-circle'}
            handleCloseAlert={() => {
              this.props.onCloseAlertSuccess({
                hasSucced: false,
                message: ''
              });
            }}
            type={'success'}
          />
        )}
        <div className="col-12 col-md-9 rp-margin-item-cart">
          <div className="form-item">
            <label htmlFor="add-item-to-cart">
              {i18n.t('cartPage.addItemsToCart')}:
            </label>
            <div className="form-inputs">
              <SearchBar
                hideSearchButton={true}
                handleOnSubmitSearch={this.submitSearch}
                handleOnSelectedPart={this.selectedPart}
                hideModels={true}
                hideViewAll={true}
                placeholder={i18n.t('cartPage.searchByPartNumber')}
              />
              <input
                type="number"
                min={1}
                step={1}
                id="add-items-to-cart-quantity"
                defaultValue="1"
                placeholder="Qty"
                onChange={this.changeQuantity}
                className="quantity-input"
              />
              <Button
                action={this.addItem}
                label={i18n.t('common.add')}
                buttonClass="primary-button btn-add-item"
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-3 col-cart-bulk-actions">
          <div className="buttons-container">
            <button onClick={onClearCart}>
              {i18n.t('cartPage.clearCart')}
            </button>
            {/* {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
              ''
            ) : (
              <button onClick={e => this.props.onUploadFile()}>
                {i18n.t('cartPage.loadOrderFromFile')}
              </button>
            )} */}
            <button onClick={e => this.props.onUploadFile()}>
              {i18n.t('cartPage.loadOrderFromFile')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
